







































































































































































































































































































































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { mapGetters } from "vuex";
import { IWitness, ISortParameters, ITransaction } from "@/interfaces";
import CryptoCompareService from "@/services/crypto-compare";

@Component({
  computed: {
    ...mapGetters("network", ["delegates", "isListed"]),
    ...mapGetters("currency", { currencySymbol: "symbol" }),
  },
})
export default class TableTransactionsDesktop extends Vue {
  @Prop({
    required: true,
    validator: (value) => {
      return Array.isArray(value) || value === null;
    },
  })
  public transactions: ITransaction[] | null;
  @Prop({ required: false, default: false }) public showConfirmations: boolean;
  @Prop({ required: false, default: "top" }) public tooltipPlacement: string;

  private delegates: IWitness[];
  private isListed: boolean;
  private currencySymbol: string;

  get columns() {
    const feeClasses = ["hidden", "lg:table-cell"];

    feeClasses.push(this.showConfirmations ? "pr-10 xl:pr-4" : "end-cell");

    let columns = [
      {
        label: this.$t("TRANSACTION.BLOCK_ID"),
        field: "block",
        type: "number",
        thClass: "start-cell",
        tdClass: "start-cell ",
      },
      {
        label: this.$t("COMMON.ID"),
        field: "id",
        thClass: "text-center  lg:base-cell",
        tdClass: "text-center lg:base-cell",
      },
      {
        label: this.$t("COMMON.TIMESTAMP"),
        field: "timestamp",
        type: "number",
        thClass: "text-center hidden md:table-cell break-all",
        tdClass: "text-center hidden md:table-cell wrap-timestamp break-all ",
      },
      {
        label: this.$t("TRANSACTION.SENDER"),
        field: "sender",
        thClass: "text-center",
        tdClass: "text-center",
      },
      {
        label: this.$t("TRANSACTION.RECIPIENT"),
        field: "receiver",
        thClass: "text-center",
        tdClass: "text-center",
      },
      {
        label: this.$t("TRANSACTION.TYPE"),
        field: "type",
        thClass: "text-center",
        tdClass: "text-center",
      },
      {
        label: this.$t("TRANSACTION.AMOUNT"),
        field: "amount",
        thClass: "end-cell text-center",
        tdClass: "end-cell text-center",
      },
    ];

    if (this.showConfirmations) {
      columns = columns.filter((column) => column.field !== "vendorField");

      columns.push({
        label: this.$t("COMMON.CONFIRMATIONS"),
        field: "confirmations",
        type: "number",
        // @ts-ignore
        sortable: false,
        thClass: "end-cell hidden xl:table-cell not-sortable",
        tdClass: "end-cell hidden xl:table-cell",
      });
    }

    return columns;
  }


  private emitSortChange(params: ISortParameters[]) {
    this.$emit("on-sort-change", params[0]);
  }
}
